import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "field"];

  connect() {
    this.update();
  }

  update() {
    this.fieldTargets.forEach((field) => {
      const source = this.selectTargets.find(
        (select) => select.dataset.conditionalFieldName === field.dataset.conditionalFieldSource,
      );
      const allowed = (field.dataset.conditionalFieldWhen || "").split(" ");
      const visible = !!source && allowed.includes(source.value);

      field.classList.toggle("hidden", !visible);
      field.querySelectorAll("input, textarea, select").forEach((input) => {
        input.disabled = !visible;
      });
    });
  }
}
